import {
  AccessTime,
  MessageOutlined,
  ThumbUpOutlined,
} from "@mui/icons-material";
import { ButtonProps } from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import { Card } from "../../../components/Card";
import { CountUp } from "../../../components/CountUp";
import { Dialog } from "../../../components/Dialog";
import { Form } from "../../../types/forms";
import { useStyles } from "../styles";

type AnalyticsFormProps = {
  data: Form | null;
  open: boolean;
  onClose: () => void;
};

export function Analytics({ data, open, onClose }: AnalyticsFormProps) {
  const styles = useStyles();
  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Fechar",
        onClick: onClose,
      },
    ];
  }, [onClose]);

  return (
    <Dialog
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      title={data?.nameForm}
      open={open}
      actions={actions}
    >
      <div className={styles.rootContentRow}>
        <Card className={styles.rootCard} variant="outlined">
          <Typography
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontWeight={500}
          >
            <AccessTime />
            &nbsp;Acessos
          </Typography>
          <CountUp align="center" end={data?.acessos} />
        </Card>
        <Card className={styles.rootCard} variant="outlined">
          <Typography
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontWeight={500}
          >
            <MessageOutlined />
            &nbsp;Respostas
          </Typography>
          <CountUp align="center" end={data?.respostas} />
        </Card>
        <Card className={styles.rootCard} variant="outlined">
          <Typography
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontWeight={500}
          >
            <ThumbUpOutlined />
            &nbsp;Engajamento
          </Typography>
          <CountUp
            align="center"
            end={data?.engajamento}
            decimals={2}
            suffix="%"
          />
        </Card>
      </div>
    </Dialog>
  );
}
